__turbopack_context__.v({
  "areaBlurb": "style-module-scss-module__OHjGDa__areaBlurb",
  "areaSwitcherWrap": "style-module-scss-module__OHjGDa__areaSwitcherWrap",
  "backToMarketsIcon": "style-module-scss-module__OHjGDa__backToMarketsIcon",
  "backToMarketsLink": "style-module-scss-module__OHjGDa__backToMarketsLink",
  "blurbHeading": "style-module-scss-module__OHjGDa__blurbHeading",
  "blurbText": "style-module-scss-module__OHjGDa__blurbText",
  "component": "style-module-scss-module__OHjGDa__component",
  "content": "style-module-scss-module__OHjGDa__content",
  "ctaButton": "style-module-scss-module__OHjGDa__ctaButton",
  "ctaHeading": "style-module-scss-module__OHjGDa__ctaHeading",
  "ctaSection": "style-module-scss-module__OHjGDa__ctaSection",
  "ctaText": "style-module-scss-module__OHjGDa__ctaText",
  "faqHeading": "style-module-scss-module__OHjGDa__faqHeading",
  "heroSection": "style-module-scss-module__OHjGDa__heroSection",
  "heroSectionCompact": "style-module-scss-module__OHjGDa__heroSectionCompact",
  "marketFaqSnapshot": "style-module-scss-module__OHjGDa__marketFaqSnapshot",
  "page-title": "style-module-scss-module__OHjGDa__page-title",
  "subtitle": "style-module-scss-module__OHjGDa__subtitle",
  "visuallyHidden": "style-module-scss-module__OHjGDa__visuallyHidden",
});
